<template>
  <section
    v-loading="loading"
    id="uti-panel-selected"
    class="selected-test-preview"
  >
    <div class="test-panel-name">
      <p class="name">Selected Panels</p>
      <p class="viewPanel" @click="showNailTests">
        {{ getSelectedGroupTitle() }}
      </p>
    </div>
    <div class="default-modal" v-if="nailTestsPopup">
      <el-dialog v-model="nailTestsPopup">
        <div class="dialog-header">
          <span class="header-part">Womens Health</span>
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="nailTestsPopup = false"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <div class="popup-panels-blocks">
          <ul>
            <li
              class="toxicology-text-panels"
              v-for="(category, index) of getCaseCategoryData()"
              :key="index"
            >
              <h3 class="test-group-title">
                {{ category.panel_title }}
              </h3>
              <ul class="check-list-gastro">
                <li
                  v-for="(item, index) of getCategoryWiseTestsData(
                    'WOMENS_HEALTH',
                    category.panel_id,
                    category.group_id
                  )"
                  :key="index"
                >
                  <el-checkbox-group v-model="panelsTestsData.selectedTestIds">
                    <el-checkbox :label="item._id" :value="item" disabled>{{
                      item.test_name
                    }}</el-checkbox>
                  </el-checkbox-group>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";

import { mapGetters } from "vuex";

export default {
  mixins: [UserPermissionsHelper, AppHelper],
  components: {},
  props: ["panelTestsData", "test", "allSelectedTests"],

  data() {
    return {
      activeNameCollapse: "",
      NailPanels: [],
      selectedNailPanels: [],
      NailGroupId: "",
      testsData: [],
      existed: [],
      loading: false,
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: [],
      },
      allTests: "",
      nailTestsPopup: false,
    };
  },
  async mounted() {
    this.loading = true;
    this.allTests = this.allSelectedTests;
    this.panelsTestsData = this.panelTestsData;
    this.loading = false;
  },
  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser", "getUserPrimaryLabId"]),
    ...mapGetters("cases", ["getCaseInformation", "getCorriellTestPanels"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
      "getNewLabGroupWiseTestsData",
    ]),
  },
  methods: {
    showNailTests() {
      this.nailTestsPopup = true;
    },

    getCategoryWiseTestsData(caseType, category, group_id) {
      return this.getNewLabGroupPanelTests.filter(
        (el) =>
          el.case_type_code == caseType &&
          el.panel_id == category &&
          el.group_id == group_id
      );
    },

    getCaseCategoryData() {
      let data = this.getNewLabGroupPanelTests.filter(
        (e) =>
          this.NailGroupId == e.group_id &&
          this.selectedNailPanels.includes(e.panel_id)
      );

      return data.reduce((acc, current) => {
        const x = acc.find((item) => item.panel_id == current.panel_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
    },

    getSelectedGroupTitle() {
      let selectedGroup = this.panelsTestsData.selectedGroup.filter(
        (e) => e.case_type_code == "WOMENS_HEALTH"
      );

      if (selectedGroup.length) {
        const selectedGroupId = selectedGroup[0].group_id;

        const matchedGroup = this.getNewLabGroupWiseTests.find(
          (group) => group._id == selectedGroupId
        );
        this.NailPanels = matchedGroup?.group_title || "No matching group";
        this.NailGroupId = matchedGroup?.group_id;

        this.selectedNailPanels = selectedGroup?.[0]?.panel_ids;
      }

      return this.NailPanels;
    },
  },
};
</script>
<style lang="scss"></style>
